import { Operation } from '~/interfaces/device.interface';
import { LegrandGateway } from './LegrandGateway.model';
import operations from '~/helpers/device-operations';

export class NBG extends LegrandGateway {

    get deviceOperations(): Operation[]  {
        return super.deviceOperations.concat([
            operations.dump({ callback: this.dump }),
            operations.orderReboot({ callback: this.orderReboot, disabled: this.isOrderRebootDisabled }),
            operations.setDump({ callback: this.setDump }),
        ]);
    }
}
